class Logger {

    trace = (message: any) => this.Trace(message);

    Trace = async (message: any) => {
        if (message != null) {
            console.trace(`[${this.GenerateLogDateTime()}] - ${message}`);
        }
    }

    log = (message: any) => this.Info(message)
    Log = (message: any) => this.Info(message)

    info = (message: any) => this.Info(message)
    Info = async (message: any) => {
        if (message != null) {
            console.log(`[${this.GenerateLogDateTime()}] - ${message}`);
        }
    }

    debug = (message: any) => this.Debug(message)
    Debug = async (message: any) => {
        if (message != null) {
            console.debug(`[${this.GenerateLogDateTime()}] - ${message}`);
        }
    }

    warn = (message: any) => this.Warn(message)
    Warn = async (message: any) => {
        if (message != null) {
            console.warn(`[${this.GenerateLogDateTime()}] - ${message}`);
        }
    }

    error = (message: any, error?: (Error | undefined | any)) => this.Error(message, error)
    Error = async (message: any, error?: (Error | undefined | any)) => {
        if (message != null) {
            let dateTime = this.GenerateLogDateTime();
            if (error == null) {
                console.error(`[${dateTime}] - ${message}`);
            }
            else {
                if (typeof error === 'string') {
                    console.error(`[${dateTime}] - ${message} - ${error}`);
                }
                else {
                    console.error(`[${dateTime}] - ${message}\nName: ${error.name}\nMessage: ${error.message}`);
                }
            }
        }
    }

    GenerateLogDateTime = () => {
        let date = new Date();
        return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}:${date.getMilliseconds()}`;
    }
}

let log: Logger = new Logger();
export { log };